var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRank15 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 111,
  height: 103,
  viewBox: "0 0 111 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddd_1_393)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_1_393)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.924 76H35.732L47.786 17.944H39.094C37.782 21.224 35.896 23.602 33.272 25.078C30.648 26.554 27.45 27.292 23.514 27.292H22.448L20.808 35H32.37L23.924 76ZM88.2504 28.276L90.1364 19.092H59.8784L51.1864 50.662H61.7644C62.2564 49.022 63.0764 47.792 64.2244 46.808C65.2904 45.824 66.6844 45.332 68.4064 45.332C70.2104 45.332 71.5224 45.742 72.3424 46.48C73.1624 47.3 73.5724 48.612 73.5724 50.58C73.5724 51.482 73.4904 52.548 73.3264 53.696C73.1624 54.844 72.9164 56.156 72.6704 57.632C71.8504 61.404 70.7844 64.274 69.3084 66.16C67.8324 68.046 65.8644 68.948 63.4044 68.948C61.6824 68.948 60.5344 68.456 59.9604 67.39C59.3864 66.406 59.1404 65.176 59.1404 63.7C59.1404 62.962 59.1404 62.224 59.3044 61.486C59.3864 60.83 59.4684 60.092 59.6324 59.436H48.3164L48.0704 60.994C47.9064 61.814 47.8244 62.716 47.6604 63.618C47.4964 64.52 47.4964 65.422 47.5784 66.324C47.5784 67.718 47.7424 69.03 48.2344 70.342C48.7264 71.654 49.4644 72.802 50.6124 73.786C51.6784 74.77 53.1544 75.59 54.9584 76.246C56.7624 76.902 59.0584 77.148 61.8464 77.148C65.5364 77.148 68.7344 76.656 71.3584 75.59C73.9824 74.606 76.1144 73.13 77.9184 71.244C79.7224 69.358 81.1164 67.062 82.2644 64.438C83.3304 61.814 84.2324 58.944 84.8884 55.664C85.3804 53.368 85.6264 51.154 85.6264 48.94C85.6264 47.3 85.3804 45.824 85.0524 44.348C84.6424 42.954 83.9864 41.724 83.1664 40.658C82.3464 39.592 81.1984 38.772 79.8044 38.116C78.3284 37.46 76.6064 37.132 74.5564 37.132C72.0144 37.132 69.8004 37.542 67.9144 38.198C66.0284 38.854 64.3884 40.002 62.9944 41.478H62.8304L66.8484 28.276H88.2504Z",
  fill: "#FAFAFA"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddd_1_393",
  x: -11,
  y: 0.94397,
  width: 121.136,
  height: 101.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_393"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_1_393",
  result: "effect2_dropShadow_1_393"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_1_393",
  result: "effect3_dropShadow_1_393"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1_393",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_1_393",
  x: 16.808,
  y: 17.944,
  width: 77.3285,
  height: 67.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_393"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_393",
  result: "shape"
})))));
export default SvgRank15;